import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { FileSize, compressorFile } from "../../../../shared/lib";

// Определяем степень сжатия
var getQuality = function getQuality(size) {
  if (size) {
    if (size <= FileSize['4Mb']) return {
      preview: 0.4,
      original: 0.8
    };
    if (size <= FileSize['8Mb']) return {
      preview: 0.2,
      original: 0.8
    };
    if (size <= FileSize['9Mb']) return {
      preview: 0.2,
      original: 0.6
    };
  }
  // Свыше не обрабатываем файлы
  return null;
};

/**
 * @param file - прикрепляемый файл в формате File.
 * @param callback - Выполняем действие.
 * Пример применения callback:
 * действие: Открываем модалку без большой задержки
 * замечание: Задержка появляется при сжатии большого файла
 */
export var prepareImage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, callback) {
    var quality, _compressedPreviewImg, compressedPreviewImg, compressedImg;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          quality = getQuality(file === null || file === void 0 ? void 0 : file.size); // Размер файла превышен
          if (!(!quality || !file)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", null);
        case 3:
          callback === null || callback === void 0 || callback();
          if (!(file.size <= FileSize['300Kb'])) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", {
            image: file,
            imagePreview: file
          });
        case 6:
          if (!(file.size <= FileSize['3Mb'])) {
            _context.next = 11;
            break;
          }
          _context.next = 9;
          return compressorFile(file, 0.8);
        case 9:
          _compressedPreviewImg = _context.sent;
          return _context.abrupt("return", {
            image: file,
            imagePreview: _compressedPreviewImg
          });
        case 11:
          _context.next = 13;
          return compressorFile(file, quality.preview);
        case 13:
          compressedPreviewImg = _context.sent;
          _context.next = 16;
          return compressorFile(file, quality.original);
        case 16:
          compressedImg = _context.sent;
          return _context.abrupt("return", {
            image: compressedImg,
            imagePreview: compressedPreviewImg
          });
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function prepareImage(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getAcceptFile = function getAcceptFile(ref, acceptTypeList) {
  if (!ref.current) return null;
  var extension = ".".concat(ref.current.value.split('.').pop()).toLowerCase();
  return acceptTypeList.includes(extension);
};